module.exports = __webpack_public_path__ + "img/yh.60decb6a.gif";